import { Vista } from "../../types";

interface NavTabsProps {
  vistaActual: Vista;
  onVistaChange: (vista: Vista) => void;
}

export function NavTabs({ vistaActual, onVistaChange }: NavTabsProps) {
  const tabs: { id: Vista; label: string }[] = [
    { id: "dashboard", label: "Dashboard" },
    { id: "holdings", label: "Holding" },
    { id: "clientes", label: "Clientes" },
    { id: "analisis", label: "Estudios" },
    { id: "casos", label: "Solicitudes" },
    { id: "reclamos", label: "Reclamos" },
    { id: "cobro", label: "Cobro" },
    { id: "tesoreria", label: "Tesoreria" },
  ];

  return (
    <nav className="bg-white border-b border-slate-200 px-6">
      <div className="flex gap-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onVistaChange(tab.id)}
            className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
              vistaActual === tab.id
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-slate-600 hover:text-slate-800 hover:border-slate-300"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </nav>
  );
}
